import { Spinner } from '@yoast/ui-library';

/**
 * Loading indicator component displays a centered spinner and loading message.
 */
export const RouteGuardLoading: React.FC = () => (
  <div className="yst-flex yst-min-h-screen yst-items-center yst-justify-center">
    <div className="yst-flex yst-items-center yst-gap-3 yst-text-center">
      <Spinner variant="primary" />
      <span className="yst-italic">
        Just a moment while we get things ready for you...
      </span>
    </div>
  </div>
);

export default RouteGuardLoading;
